import { Component } from "@angular/core";
import { MatDialog as MatDialog } from "@angular/material/dialog";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import _ from "lodash";
import moment from "moment";
import { Customer } from "src/app/models/customer.model";
import { Marque } from "src/app/models/marque.model";
import { Printer } from "src/app/models/printer.model";
import { FlowType } from "src/app/models/proofreading.model";
import { ExternStateName } from "src/app/models/states.model";
import { TITLESPAGES } from "src/app/models/titlePage.model";
import { User } from "src/app/models/users.model";
import { AlertService } from "src/app/services/alert.service";
import { AuthService } from "src/app/services/auth.service";
import { CustomerService } from "src/app/services/customer.service";

import { LivecoAPIService } from "src/app/services/liveco-api.service";
import { LoaderService } from "src/app/services/loader.service";
import { StateMachineService } from "src/app/services/machine-state.service";
import { MarqueService } from "src/app/services/marque.service";
import { ProjectService } from "src/app/services/project.service";
import { UsersService } from "src/app/services/user.service";
import { FiltersComponent } from "src/app/shared/components/filters/filters.component";

export interface IProjectFilters {
    __search: string | undefined;

    all_project: boolean | undefined;
    is_old: boolean | undefined;
    projects_archived: boolean | undefined;

    all_customer_project: boolean | undefined;
    customer: Customer | undefined;
    cpp: User | undefined;
    brand: Marque | undefined;
    printer: Printer | undefined;
    state_slugs: ExternStateName[],
    flows_slugs: FlowType[] | undefined,


    date_start: Date | undefined;
    date_end: Date | undefined;
}

@Component({
    selector: "app-project-filters",
    templateUrl: "./project-filters.component.html",
    styleUrls: ["./project-filters.component.scss"],
})
export class ProjectFiltersComponent extends FiltersComponent<IProjectFilters> {

    protected override _filters: IProjectFilters = {
        __search: undefined,
        date_start: undefined,
        date_end: undefined,

        all_project: undefined,
        is_old: undefined,
        projects_archived: undefined,

        all_customer_project: undefined,
        customer: undefined,
        cpp: undefined,
        brand: undefined,
        printer: undefined,
        state_slugs: [],
        flows_slugs: undefined
    };

    protected override _resettedFilters: IProjectFilters = {
        __search: "",
        date_start: undefined,
        date_end: undefined,

        all_project: undefined,
        is_old: undefined,
        projects_archived: undefined,

        all_customer_project: undefined,
        customer: undefined,
        cpp: undefined,
        brand: undefined,
        printer: undefined,
        state_slugs: [],
        flows_slugs: undefined
    };

    customers: Customer[] = [];
    printers: Printer[] = [];
    brands: Marque[] = [];
    cpps: User[] = [];
    states_slugs: ExternStateName[] = [];
    flows_slugs: FlowType[] = [];

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected s_alert: AlertService,
        protected s_loader: LoaderService,
        protected dialog: MatDialog,
        protected s_auth: AuthService,
        protected titleService: Title,
        protected liveco: LivecoAPIService,
        protected s_projects: ProjectService,
        protected s_customer: CustomerService,
        protected s_marques: MarqueService,
        protected s_users: UsersService,
        protected s_state_machine: StateMachineService,
        protected translate: TranslateService
    ) {
        super(route, router, s_alert, s_loader, dialog, s_auth, titleService, liveco, s_projects, s_customer);
        this.titleService.setTitle(TITLESPAGES.PROJECTS_TITLE);
    }

    override async ngOnInit(): Promise<void> {
        // // Set the default query upon FIND
        // this.s_projects.callbacks.find = () => this.query;

        this.customers = this.isClient() ? [] : await this.s_customer.find({});
        this.printers = this.isClient() ? [] : (await this.liveco.find({}, 'printers')).result;
        this.brands = this.isClient() ? [] : await this.s_marques.find({});
        this.cpps = this.isClient() ? [] : await this.s_users.find({ attributes_name: 'CPP', $sort: { username: 1 } });
        this.states_slugs = await this.s_state_machine.getStatesSlugs();
        this.flows_slugs = Object.values(FlowType);
    }

    submit() {
        this.onFilter.emit(this.filters);
    }

    async resetForm() {
        this.page.$skip = 0;
        this.filters = {
            __search: "",
            date_start: undefined,
            date_end: undefined,

            all_project: true,
            is_old: undefined,
            projects_archived: undefined,

            all_customer_project: undefined,
            customer: undefined,
            cpp: undefined,
            brand: undefined,
            printer: undefined,
            state_slugs: [],
            flows_slugs: undefined
        };
        this.submit();
    }

    public updateAllProjectsState = (): void => {
        if (this.filters.cpp || this.filters.projects_archived || this.filters.is_old) {
            this.filters.all_project = true;
        }
    };

    public onDateSelected = (selected: 'start' | 'end'): void => {
        if (selected === 'start' && this.filters.date_start) {
            if (moment(this.filters.date_start).isSameOrAfter(moment().add(1, 'days'))) {
                this.filters.date_start = moment().toDate();
            }

            if (!this.filters.date_end || moment(this.filters.date_start).isSameOrAfter(moment(this.filters.date_end))) {
                this.filters.date_end = moment().add(1, 'days').toDate();
            }
        } else if (selected === 'end' && this.filters.date_end) {
            if (moment(this.filters.date_end).isAfter(moment().add(1, 'days'))) {
                this.filters.date_end = moment().add(1, 'days').toDate();
            }

            if (!this.filters.date_start || moment(this.filters.date_start).isSameOrAfter(moment(this.filters.date_end))) {
                this.filters.date_start = moment(this.filters.date_end).subtract(1, 'month').toDate();
            }
        }
    };
}
